/* LeidingDeal Predictive Search
   Hangt aan elke <form action="/search"> met een <input type="search">.
   Gebruikt Shopify's /search/suggest.json endpoint + fallback search.json voor SKU-matches. */
(function () {
  'use strict';

  var SUGGEST = '/search/suggest.json';
  var DEBOUNCE_MS = 180;
  var MIN_CHARS = 2;
  var LIMIT = 6;

  var cache = {};

  function money(cents) {
    var n = Math.round(cents) / 100;
    var r=n.toFixed(2).split('.');r[0]=r[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');return '€ '+r[0]+','+r[1];
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Normaliseer maat-varianten: "1/2" ≡ "1-2" ≡ "½", "3/4" ≡ "3-4" ≡ "¾".
     Geeft array met alternatieven voor fallback search. */
  function queryVariants(q) {
    var out = [q];
    var FRAC = { '½':'1/2','¼':'1/4','¾':'3/4','⅓':'1/3','⅔':'2/3','⅛':'1/8','⅜':'3/8','⅝':'5/8','⅞':'7/8' };
    var expanded = q;
    Object.keys(FRAC).forEach(function(k){ expanded = expanded.split(k).join(FRAC[k]); });
    if (expanded !== q) out.push(expanded);
    // "1/2" → "1-2" (onze handles gebruiken dash)
    if (/\d\s*\/\s*\d/.test(expanded)) {
      out.push(expanded.replace(/(\d)\s*\/\s*(\d)/g, '$1-$2'));
    }
    // "1-2" → "1/2" (als user typt met dash)
    if (/\d-\d/.test(expanded) && !/\//.test(expanded)) {
      out.push(expanded.replace(/(\d)-(\d)/g, '$1/$2'));
    }
    // Dedupe
    return out.filter(function(v,i){ return out.indexOf(v) === i; });
  }

  /* Quick heuristic: zou dit een SKU/artnr kunnen zijn? */
  function looksLikeSku(q) {
    var s = q.replace(/\s/g, '');
    // 5+ chars, majority alphanumeric, no spaces
    if (s.length < 4) return false;
    var alnum = (s.match(/[A-Za-z0-9]/g) || []).length;
    return alnum / s.length > 0.8 && /\d/.test(s);
  }

  /* Normaliseer een artikelnummer/SKU voor exacte vergelijking:
     hoofdletters weg, spaties/punten/streepjes weg → "AB-12.30" ≡ "ab 1230". */
  function normSku(s) {
    return String(s || '').toLowerCase().replace(/[\s.\-_/]/g, '');
  }

  /* Artikelnummer (B7/B8): backfill mapte custom.sku → leidingdeal.artikelnummer,
     wat gelijk is aan de variant-SKU. suggest.json/search.json geven geen metafields,
     dus we lezen de eerste variant-SKU (of product-level sku). */
  function articleNo(p) {
    if (p._matchedSku) return p._matchedSku;
    if (p.variants && p.variants.length && p.variants[0].sku) return p.variants[0].sku;
    return p.sku || '';
  }

  /* Z2b: geef de exact matchende SKU terug over ALLE varianten (niet enkel
     variants[0]), of null. Zo krijgt een artikelnummer dat op variant 2+ staat
     ook een match (badge + Enter-to-product). Vergelijkt genormaliseerd. */
  function matchingSku(p, nq) {
    if (p.variants && p.variants.length) {
      for (var v = 0; v < p.variants.length; v++) {
        var vs = p.variants[v] && p.variants[v].sku;
        if (vs && normSku(vs) === nq) return vs;
      }
    }
    if (p.sku && normSku(p.sku) === nq) return p.sku;
    return null;
  }

  /* Bouwmarktprijs = compare_at_price wanneer hoger dan de verkoopprijs (cents).
     Conventie identiek aan product-card.liquid (struck, #B91C1C). */
  function bouwmarktCents(p, priceCents) {
    var c = (p.compare_at_price_max !== undefined && p.compare_at_price_max !== null) ? p.compare_at_price_max
          : (p.compare_at_price_min !== undefined && p.compare_at_price_min !== null) ? p.compare_at_price_min
          : (p.variants && p.variants[0] && p.variants[0].compare_at_price) ? p.variants[0].compare_at_price
          : null;
    if (c == null) return null;
    c = Math.round(parseFloat(c) * 100); // suggest.json geeft euro-decimalen, geen cents
    return (c > priceCents) ? c : null;
  }

  /* Prijs in cents uit een suggest-resultaat halen.
     suggest.json geeft prijzen als euro-decimalen ("11.99"), niet als cents. */
  function priceCents(p) {
    if (p.price !== undefined && p.price !== null) return Math.round(parseFloat(p.price) * 100);
    if (p.price_min !== undefined && p.price_min !== null) return Math.round(parseFloat(p.price_min) * 100);
    if (p.variants && p.variants[0] && p.variants[0].price !== undefined) return Math.round(parseFloat(p.variants[0].price) * 100);
    return null;
  }

  function buildDropdown(form) {
    var dd = document.createElement('div');
    dd.className = 'ld-predictive-dropdown';
    dd.style.cssText =
      'position:absolute;top:calc(100% + 4px);left:0;right:0;background:#fff;' +
      'border:1px solid #e5e7eb;border-radius:10px;box-shadow:0 10px 30px rgba(27,42,74,0.12);' +
      'max-height:420px;overflow-y:auto;z-index:60;display:none;';
    form.style.position = 'relative';
    form.appendChild(dd);
    return dd;
  }

  function productRow(p, isExact) {
    var img = (p.featured_image && p.featured_image.url) || p.image || 'https://placehold.co/80x80/f6f7fa/1B2A4A?text=?';
    if (typeof img === 'string' && img.indexOf('placeholder_productfoto') !== -1) {
      img = 'https://placehold.co/80x80/f6f7fa/1B2A4A?text=Foto';
    }
    var cents = priceCents(p);
    var price = (cents != null) ? money(cents) : '';
    var bouwmarkt = (cents != null) ? bouwmarktCents(p, cents) : null;

    // Merk-regel: merk + artikelnummer (B8 — installateur zoekt op artnr).
    var artnr = articleNo(p);
    var metaBits = [];
    if (p.vendor) metaBits.push(escapeHtml(p.vendor));
    if (artnr) metaBits.push('Art.nr. ' + escapeHtml(artnr));
    var metaLine = metaBits.join(' · ');

    var priceHtml = '';
    if (price) {
      priceHtml = '<span style="font-size:13px;font-weight:800;color:#F26522;">' + price + '</span>';
      if (bouwmarkt) {
        priceHtml += '<span style="font-size:11px;color:#B91C1C;text-decoration:line-through;margin-left:6px;">' + money(bouwmarkt) + '</span>';
      }
    }

    // Z2a: "Uitverkocht"-label als suggest.json meldt dat het product niet
    // leverbaar is (available === false). Ontbreekt het veld, dan tonen we niets.
    var soldOutHtml = (p.available === false)
      ? '<span style="display:inline-block;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.4px;color:#6C757D;background:#f3f4f6;border:1px solid #e5e7eb;border-radius:4px;padding:1px 5px;">Uitverkocht</span>'
      : '';

    var badge = isExact
      ? '<span style="display:inline-block;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.4px;color:#fff;background:#F26522;border-radius:4px;padding:1px 5px;margin-bottom:2px;">Artikelnr.-match</span>'
      : '';

    return '<a href="' + escapeHtml(p.url) + '" class="ld-ps-item" ' +
      'style="display:flex;gap:10px;padding:8px 12px;text-decoration:none;color:inherit;border-bottom:1px solid #f3f4f6;align-items:center;transition:background 0.15s;' +
      (isExact ? 'background:#fff7f2;' : '') + '" ' +
      'onmouseover="this.style.background=\'#fafbff\'" onmouseout="this.style.background=\'' + (isExact ? '#fff7f2' : '') + '\'">' +
      '<img src="' + escapeHtml(img) + '" alt="" width="44" height="44" ' +
      'style="width:44px;height:44px;object-fit:contain;background:#fafbff;border-radius:6px;padding:4px;flex-shrink:0;" loading="lazy">' +
      '<div style="flex:1;min-width:0;">' +
      badge +
      '<div style="font-size:13px;font-weight:600;color:#1B2A4A;line-height:1.3;' +
      'overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">' +
      escapeHtml(p.title) + '</div>' +
      (metaLine ? '<div style="font-size:10px;color:#6C757D;margin-top:1px;">' + metaLine + '</div>' : '') +
      ((priceHtml || soldOutHtml) ? '<div style="margin-top:2px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;">' + priceHtml + soldOutHtml + '</div>' : '') +
      '</div>' +
      '</a>';
  }

  function render(dd, products, collections, query, exactUrl) {
    if (!products.length && !collections.length) {
      dd.innerHTML =
        '<div style="padding:14px;text-align:center;color:#6C757D;font-size:13px;">' +
        'Geen suggesties voor <b>' + escapeHtml(query) + '</b>' +
        '<br><a href="/search?q=' + encodeURIComponent(query) +
        '" style="color:#F26522;font-weight:600;font-size:12px;">Volledig zoeken &rarr;</a>' +
        '</div>';
      dd.style.display = 'block';
      return;
    }
    var html = '';
    if (products.length) {
      html += '<div style="padding:8px 12px 4px;font-size:10px;font-weight:700;text-transform:uppercase;color:#6C757D;letter-spacing:.5px;">Producten</div>';
      products.slice(0, LIMIT).forEach(function (p) {
        html += productRow(p, exactUrl && p.url === exactUrl);
      });
    }
    if (collections.length) {
      html += '<div style="padding:8px 12px 4px;font-size:10px;font-weight:700;text-transform:uppercase;color:#6C757D;letter-spacing:.5px;border-top:1px solid #f3f4f6;">Categorieën</div>';
      collections.slice(0, 3).forEach(function (c) {
        html +=
          '<a href="' + escapeHtml(c.url) + '" style="display:block;padding:6px 12px;font-size:12px;color:#1B2A4A;text-decoration:none;" ' +
          'onmouseover="this.style.background=\'#fafbff\'" onmouseout="this.style.background=\'\'">' +
          escapeHtml(c.title) + '</a>';
      });
    }
    html += '<a href="/search?q=' + encodeURIComponent(query) + '" ' +
      'style="display:block;padding:10px 12px;background:#F26522;color:#fff;font-weight:700;font-size:12px;text-align:center;text-decoration:none;border-bottom-left-radius:10px;border-bottom-right-radius:10px;">' +
      'Bekijk alle resultaten voor &ldquo;' + escapeHtml(query) + '&rdquo; &rarr;</a>';
    dd.innerHTML = html;
    dd.style.display = 'block';
  }

  /* Verzamel producten uit suggest.json resp. */
  function pickProducts(data) {
    return (data && data.resources && data.resources.results && data.resources.results.products) || [];
  }
  function pickCollections(data) {
    return (data && data.resources && data.resources.results && data.resources.results.collections) || [];
  }

  /* Query Shopify suggest endpoint.
     LET OP: geldige fields zijn alleen author, body, product_type, tag, title,
     variants.barcode, variants.sku, variants.title, vendor — een ongeldig veld
     (zoals kaal 'sku') geeft een HTTP 422 en dus nul suggesties. */
  function fetchSuggest(q) {
    var url = SUGGEST +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* Fallback bij 0 producten of SKU-achtige queries: zelfde suggest-endpoint
     maar breder (body + variants.barcode erbij), zodat artikelnummers en
     barcodes ook matchen. (/search.json bestaat niet als JSON-endpoint —
     de oude fallback daarop gaf altijd HTML terug en dus nooit resultaten.) */
  function fetchSuggestWide(q) {
    var url = SUGGEST +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,body,variants.sku,variants.barcode,vendor,tag';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(pickProducts)
      .catch(function () { return []; });
  }

  /* B7: tilt het product met een exact-matchend artikelnummer naar boven en geef
     z'n URL terug (voor pin-badge + Enter-to-product). */
  function pinExactMatch(products, q) {
    var nq = normSku(q);
    if (!nq) return null;
    for (var i = 0; i < products.length; i++) {
      var ms = matchingSku(products[i], nq);
      if (ms) {
        var hit = products.splice(i, 1)[0];
        hit._matchedSku = ms; // toon de matchende variant-SKU in de rij + badge
        products.unshift(hit);
        return hit.url;
      }
    }
    return null;
  }

  function runQuery(q, callback) {
    var cacheKey = q.toLowerCase();
    if (cache[cacheKey]) { callback(cache[cacheKey]); return; }

    var variants = queryVariants(q);
    var suggestPromises = variants.map(fetchSuggest);
    var needsFallback = looksLikeSku(q);

    Promise.all(suggestPromises).then(function(results) {
      // Combine unique products + collections from all variant queries
      var seen = {};
      var products = [];
      var collections = [];
      results.forEach(function(d) {
        pickProducts(d).forEach(function(p) {
          if (!seen['p:'+p.id]) { seen['p:'+p.id] = 1; products.push(p); }
        });
        pickCollections(d).forEach(function(c) {
          if (!seen['c:'+c.id]) { seen['c:'+c.id] = 1; collections.push(c); }
        });
      });

      function finish() {
        var exactUrl = pinExactMatch(products, q);
        var result = { products: products, collections: collections, exactUrl: exactUrl };
        cache[cacheKey] = result;
        callback(result);
      }

      if (products.length === 0 || needsFallback) {
        // Fallback: bredere suggest-query (vangt SKU/barcode/body-matches)
        fetchSuggestWide(q).then(function(extra) {
          extra.forEach(function(p) {
            var key = p.id ? 'p:'+p.id : 'u:'+p.url;
            if (!seen[key]) { seen[key] = 1; products.push(p); }
          });
          finish();
        });
      } else {
        finish();
      }
    });
  }

  var uid = 0; // Z1: uniek id-nummer per combobox (meerdere zoekformulieren mogelijk)

  /* Z1: highlight-class voor de actieve optie (roving via aria-activedescendant).
     Eenmalig ingespoten; !important wint van de inline hover-achtergrond. */
  function injectStyles() {
    if (document.getElementById('ld-ps-styles')) return;
    var st = document.createElement('style');
    st.id = 'ld-ps-styles';
    st.textContent = '.ld-ps-active{background:#eef2ff !important;box-shadow:inset 3px 0 0 #F26522;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function attachForm(form) {
    var input = form.querySelector('input[type="search"]');
    if (!input || input.dataset.predictiveBound) return;
    input.dataset.predictiveBound = '1';

    injectStyles();

    var dd = buildDropdown(form);
    var timer;
    var exactUrl = null; // B7: huidige artikelnummer-exact-match (voor Enter-to-product)

    // Z1: combobox/listbox-bekabeling.
    var listId = 'ld-ps-list-' + (++uid);
    dd.id = listId;
    dd.setAttribute('role', 'listbox');
    dd.setAttribute('aria-label', 'Zoeksuggesties');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', listId);
    input.setAttribute('aria-expanded', 'false');

    // Z1: visueel verborgen live-regio die het aantal suggesties meldt.
    var status = document.createElement('div');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('role', 'status');
    status.className = 'ld-ps-status';
    status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
    form.appendChild(status);

    var options = [];     // Z1: huidige role=option elementen (de <a>'s in de dropdown)
    var activeIndex = -1; // Z1: roving-index voor aria-activedescendant

    function setExpanded(open) {
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Z1: verplaats de actieve optie (roving). Zet aria-selected + highlight-class
    // en spiegel dit naar aria-activedescendant op de input.
    function highlight(i) {
      if (activeIndex >= 0 && options[activeIndex]) {
        options[activeIndex].classList.remove('ld-ps-active');
        options[activeIndex].setAttribute('aria-selected', 'false');
      }
      activeIndex = i;
      if (i >= 0 && options[i]) {
        var opt = options[i];
        opt.classList.add('ld-ps-active');
        opt.setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', opt.id);
        if (opt.scrollIntoView) opt.scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function closeDropdown() {
      dd.style.display = 'none';
      setExpanded(false);
      highlight(-1);
    }

    // Z1: na elke render (her)indexeer de opties, reset de roving-status en meld
    // het aantal suggesties via de live-regio.
    function afterRender(r) {
      options = Array.prototype.slice.call(dd.querySelectorAll('a'));
      options.forEach(function (a, i) {
        a.setAttribute('role', 'option');
        a.id = listId + '-opt-' + i;
        a.setAttribute('aria-selected', 'false');
      });
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      setExpanded(dd.style.display !== 'none');
      var pc = Math.min(r.products ? r.products.length : 0, LIMIT);
      var cc = Math.min(r.collections ? r.collections.length : 0, 3);
      var count = pc + cc;
      status.textContent = count > 0
        ? (count === 1 ? '1 suggestie gevonden' : count + ' suggesties gevonden')
        : 'Geen suggesties';
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      exactUrl = null;
      if (q.length < MIN_CHARS) { closeDropdown(); status.textContent = ''; return; }
      timer = setTimeout(function () {
        runQuery(q, function (r) {
          exactUrl = r.exactUrl || null;
          render(dd, r.products, r.collections, q, r.exactUrl);
          afterRender(r);
        });
      }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && dd.innerHTML) {
        dd.style.display = 'block';
        setExpanded(true);
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeDropdown();
    });

    // Z1: toetsenbordbediening (combobox-patroon). Behoudt muis-hover/klik.
    input.addEventListener('keydown', function (e) {
      var open = dd.style.display !== 'none';

      if (e.key === 'Escape') {
        closeDropdown();
        return;
      }

      if (e.key === 'ArrowDown') {
        if (!open && input.value.trim().length >= MIN_CHARS && dd.innerHTML) {
          dd.style.display = 'block';
          setExpanded(true);
          open = true;
        }
        if (!options.length) return;
        e.preventDefault();
        highlight(activeIndex + 1 >= options.length ? 0 : activeIndex + 1);
        return;
      }

      if (e.key === 'ArrowUp') {
        if (!open || !options.length) return;
        e.preventDefault();
        highlight(activeIndex - 1 < 0 ? options.length - 1 : activeIndex - 1);
        return;
      }

      if (e.key === 'Home') {
        if (!open || !options.length) return;
        e.preventDefault();
        highlight(0);
        return;
      }

      if (e.key === 'End') {
        if (!open || !options.length) return;
        e.preventDefault();
        highlight(options.length - 1);
        return;
      }

      if (e.key === 'Enter') {
        // Actieve optie heeft voorrang. Zonder actieve optie valt Enter door naar
        // de submit-handler, die bij een artikelnr-match naar het product gaat.
        if (open && activeIndex >= 0 && options[activeIndex]) {
          e.preventDefault();
          window.location.href = options[activeIndex].href;
        }
      }
    });

    // B7: bij een exacte artikelnummer-match gaat Enter direct naar het product
    // i.p.v. de resultatenpagina. Geen match: normale /search submit blijft werken.
    form.addEventListener('submit', function (e) {
      if (exactUrl) {
        e.preventDefault();
        window.location.href = exactUrl;
      }
    });
  }

  function init() {
    document.querySelectorAll('form[action="/search"]').forEach(attachForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
